var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.13906 3.13906 0 7 0C10.8609 0 14 3.13906 14 7C14 10.8609 10.8609 14 7 14C3.13906 14 0 10.8609 0 7ZM4.43523 8.97956C4.84053 9.38768 5.24568 9.79565 5.65195 10.2019C5.75312 10.3031 5.91445 10.3031 6.01289 10.2019L11.025 5.19529C11.1262 5.09685 11.1262 4.93552 11.025 4.83435L9.99141 3.80076C9.89023 3.70232 9.72891 3.70232 9.62773 3.80076L5.83789 7.59334L4.36406 6.11951C4.26562 6.02107 4.10156 6.02107 4.00312 6.11951L2.97227 7.15037C2.87383 7.2488 2.87383 7.41287 2.97227 7.5113C3.46162 7.99917 3.94854 8.48948 4.43523 8.97956Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.623653ea7cf186d492a5f45a62d2437d.svg";
export { ForwardRef as ReactComponent };